import { css } from "@emotion/react";
import { Heading, H9Css } from "../Typography";

interface PricingToggleVariantProps {
  isAnnual: boolean;
  onClick: () => void;
}

const PricingToggleVariant = ({
  isAnnual,
  onClick,
}: PricingToggleVariantProps) => {
  return (
    <div
      role="button"
      onClick={onClick}
      css={css`
        cursor: pointer;
        border-radius: 25px;
        width: 234px;
        height: 38px;
        display: flex;
        align-items: center;
        position: relative;
      `}
    >
      <Heading
        level={5}
        css={css`
          flex: 1;
          text-align: center;
          color: #fff;
          transition: color 0.2s ease-in-out;
          z-index: 1;
          ${H9Css}
        `}
      >
        Annual
      </Heading>
      <Heading
        level={5}
        css={css`
          flex: 1;
          text-align: center;
          color: #fff;
          transition: color 0.2s ease-in-out;
          z-index: 1;
          ${H9Css}
        `}
      >
        Monthly
      </Heading>
      <div
        css={css`
          border: 2px solid #fff;
          position: absolute;
          z-index: 0;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          height: 35px;
          width: 113px;
          border-radius: 25px;
          transform: translateX(${!isAnnual ? "117px" : "0"});
          transition: transform 0.2s ease-in-out;
        `}
      />
    </div>
  );
};

export default PricingToggleVariant;
